<template>
  <div class="content">
    <topWell />
    <div class="mainBox">
      <listNav :title="'公司概况'" :navData="[{dictLabel:'公司介绍'},{dictLabel:'企业文化'},{dictLabel:'合作伙伴'}]" @checkPageInd="checkPageInd"/>
      <div id="company">
        <div class="tagleft" style="width: 30%">
          <img src="../../static/CompanyIntroduction.png" style="height: 80px;"/>
          <img src="../../static/line.png" class="icon-line" />
          <div class="leftTitle">公司介绍</div>
        </div>
        <div class="tagright" style="width: 70%">
          <div class="numBox">
            <div class="item">
              <div class="num"><span>{{companyInfo.totalFund}}</span>支</div>
              <div class="tit">在管基金</div>
            </div>
            <div class="item">
              <div class="num"><span>{{companyInfo.totalProject}}</span>个</div>
              <div class="tit">投资项目</div>
            </div>
            <div class="item">
              <div class="num"><span>{{companyInfo.totalEnterprise}}</span>家</div>
              <div class="tit">上市公司</div>
            </div>
          </div>
          <div class="info" v-html="companyInfo.content">
          </div>
          <div class="companyImg">
            <img :src="v.url" class="img" alt=""  v-for="v of companyInfo.firmPictureList" :key="v.ossId"/>
          </div>
        </div>
      </div>
      <div id="culture">
        <div class="box">
          <div class="tagleft" style="width: 20%">
            <img src="../../static/corporate_culture.png" style="height: 80px;"/>
            <img src="../../static/line.png" class="icon-line" />
            <div class="leftTitle">企业文化</div>
          </div>
          <div class="info" style="width: 76%">
            <div class="item">
              <div class="title">使命</div>
              <div class="tit">
                更好发挥政府投资基金引导作用，吸引撬动社会资本，服务河北产业转型升级，因地制宜发展新质生产力，打造具有河北特色的现代化产业体系，推动高质量发展，为经济强省、美丽河北做出贡献。
              </div>
            </div>
            <div class="item">
              <div class="title">定位</div>
              <div class="tit">
                政策落地执行者、产业发展助推器、资本合作召集人。
              </div>
            </div>
            <div class="item">
              <div class="title">愿景</div>
              <div class="tit">
                打造省级专业化的战略投资平台，建成具有全国影响力的产业投资发展平台。
              </div>
            </div>
            <div class="item">
              <div class="title">核心价值观</div>
              <div class="tit">
                忠诚&nbsp;&nbsp;创新&nbsp;&nbsp;担当&nbsp;&nbsp;合规&nbsp;&nbsp;专业&nbsp;&nbsp;务实
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <partner id="hzhb"/>
    <bottomNav />
  </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import partner from "@/views/partner/partner.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";
import listNav from "../../components/listNav.vue";
export default {
  components: {
    topWell,
    partner,
    bottomNav,
    listNav
  },
  data() {
    return {
      companyInfo: {}
    };
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
    scrollToElement(v) {
      if(v.dictLabel==='公司介绍'){
        const element = this.$el.querySelector(`#company`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
      if(v.dictLabel==='企业文化'){
        const element = this.$el.querySelector(`#culture`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
      if(v.dictLabel==='合作伙伴'){
        const element = this.$el.querySelector(`#hzhb`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    getCompanyInfo(){
      this.$api.getCompanyInfoApi().then(res=>{
        this.companyInfo = res.data
      })
    },
    checkPageInd(v){
      this.scrollToElement(v)
    }
  },
};
</script>
<style scoped lang="less">
.mainBox {
  font-family: "思源黑体";
  box-sizing: border-box;
  .top {
    padding: 0 6.5rem /* 104/16 */;
    min-width: 93.75rem /* 1500/16 */;
    border-bottom: 1px solid #ececec;
    // padding: 0 200px;
    padding-top: 20px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .icon-home {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
    }
    .top-right {
      display: flex;
      align-items: center;
      .text {
        width: 104px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  #company {
    margin: 0 auto;
    min-width: 93.75rem /* 1500/16 */;
    width: 93.75rem /* 1500/16 */;
    padding: 100px 6.5rem;
    padding-right: 5rem;
    display: flex;
    justify-content: space-between;
    .numBox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #1e439b;
        font-weight: bold;
        .num {
          font-size: 22px;
          span {
            font-size: 72px;
            margin-right: 5px;
          }
        }
        .tit {
          font-size: 16px;
          margin-top: 8px;
        }
      }
    }
    .info {
      margin: 65px 0;
      margin-bottom: 50px;
      font-weight: bold;
      font-size: 20px;
      font-family: "Microsoft YaHei";
      line-height: 45px;
      padding-left: 10px;
    }
    .companyImg {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .img {
        width: 300px;
        height: 180px;
        margin-right: 10px;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .tagleft {
    img {
      display: block;
    }
    .icon-line {
      width: 89px;
      margin-top: 36px;
      margin-bottom: 30px;
    }
    .leftTitle {
      font-size: 35px;
      font-weight: bold;
    }
  }
  #culture {
    padding: 150px 0;
    background: url("../../static/aboutUsBanner-light.png") no-repeat;
    background-size: cover;
    min-width: 93.75rem /* 1500/16 */;

    .box {
      padding: 0 6.5rem /* 104/16 */;
      min-width: 93.75rem /* 1500/16 */;
      display: flex;
      justify-content: space-between;
      width: 93.75rem /* 1500/16 */;
      margin: 0 auto;
    }

    .info {
      .item {
        margin-bottom: 80px;
        &:last-child {
          margin-bottom: 0;
        }
        .title {
          color: #1e439b;
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 30px;
        }
        .tit {
          font-size: 20px;
          color: #333;
        }
      }
    }
  }
}
</style>
